import React from 'react';
import { Box, Grid, Hidden, Typography } from '@mui/material';
import SkeletonList from 'components/SkeletonList';
interface Props {
	rows?: number;
}

export const PaymentBlockSkeleton = ({ rows = 2 }: Props) => {
	return (
		<Box>
			<PaymentMethodHeaderRowSkeleton />
			<SkeletonList rows={rows} />
		</Box>
	);
};

const PaymentMethodHeaderRowSkeleton = () => {
	return (
		<Grid container alignItems="flex-end" spacing={1}>
			<Grid item xs={8}>
				<Typography variant="body1">
					<SkeletonList />
				</Typography>
			</Grid>
			<Hidden smDown>
				<Grid item xs={4}>
					<Typography variant="body1">
						<SkeletonList />
					</Typography>
				</Grid>
			</Hidden>
		</Grid>
	);
};
